import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4600Model } from '../kymw4600.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type RegistTagListResponse = {
  RegistTags: { TagId: string; TagName: string }[];
};

/**
 * タグ一覧登録サービス
 * @export RegistTagListService
 * @class RegistTagListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistTagListService extends PlessJsonResponderSub<RegistTagListResponse> {
  model: KYMW4600Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    const updObj = {
      RegistTags: {
        combination: this.model.registTags.map(_ => ({
          parameter: {
            TagName: _.tagName,
          },
        })),
      },
      DeleteTags: {
        combination: this.model.deleteTags.map(_ => ({
          parameter: {
            TagId: _.tagId,
          },
        })),
      },
      UpdateTags: {
        combination: this.model.updateTags.map(_ => ({
          parameter: {
            TagId: _.tagId,
            TagName: _.tagName,
          },
        })),
      },
    };
    if (updObj.RegistTags.combination.length < 1) delete updObj.RegistTags;
    if (updObj.DeleteTags.combination.length < 1) delete updObj.DeleteTags;
    if (updObj.UpdateTags.combination.length < 1) delete updObj.UpdateTags;
    return new PlessRequest({ update: updObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetTagListService
   */
  execute(model: KYMW4600Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    if (
      this.model.registTags.length < 1 &&
      this.model.deleteTags.length < 1 &&
      this.model.updateTags.length < 1
    ) {
      if (this.calbak) this.calbak();
      return;
    }
    this.send('registTagList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTagListService
   */
  success(data: RegistTagListResponse) {
    // レスポンスデータが存在する場合にタグIDを保持
    if (data !== null && data.RegistTags)
      data.RegistTags.forEach(_d => {
        this.model.registTags.forEach(_r => {
          if (_d.TagName === _r.tagName) {
            this.model.setNewId(_r.tagId, _d.TagId);
            _r.tagId = _d.TagId;
          }
        });
      });
    if (this.calbak) this.calbak();
  }
}
